import request from '@/utils/request'

export function getOrders (data) {
  return request({
    url: '/api/admin/orders',
    method: 'post',
    data: data
  })
}

export function showOrder (data) {
  return request({
    url: '/api/admin/orders/show',
    method: 'post',
    data: data
  })
}

export function updateOrder (data) {
  return request({
    url: '/api/admin/orders/update',
    method: 'post',
    data: data
  })
}
